import { useMemo } from 'react';
import { useJiraSoftwareProjectNavigation } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/project-sidebar-navigation-resource/index.tsx';
import { useHasActiveSoftwareAccess } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/has-active-software-access/index.tsx';
import type { UseSettingsReturn } from './types.tsx';
import { extractData } from './utils/extract-data.tsx';

export const useSettings = (): UseSettingsReturn => {
	const { data, loading, error } = useJiraSoftwareProjectNavigation();

	const hasActiveSoftwareAccess = useHasActiveSoftwareAccess();
	const extractedData = useMemo(
		() => data && extractData(data, hasActiveSoftwareAccess),
		[data, hasActiveSoftwareAccess],
	);
	return { data: extractedData, loading, error };
};
